import { type AppFile, AppFileStatusSchema, type Organization } from "@repo/types";
import { db } from "../client";

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class DBOrganizationService {
	public static async getFilesAndStats(
		orgId: string,
	): Promise<{ files: AppFile[]; usedSize: number }> {
		const memberships = await db.organization.findFirst({
			where: {
				id: orgId,
			},
			select: {
				files: true,
			},
		});
		const completedFile = memberships?.files?.filter((file) => {
			return file.status === AppFileStatusSchema.Values.completed;
		});
		const size =
			completedFile
				?.filter((f) => f.status === AppFileStatusSchema.Values.completed)
				?.reduce((size, file) => {
					const totalSize = size + (file.size || 0);
					return totalSize;
				}, 0) || 0;
		return {
			files: completedFile || [],
			usedSize: size / 1000000,
		};
	}

	public static async getOrganizationById(
		id: string,
	): Promise<Organization | null> {
		return db.organization.findUnique({
			where: {
				id,
			},
		});
	}

	/**
	 * Get the effective auto-archive duration for an organization.
	 * Always returns a number (default from config).
	 * This field is not optional - it always has a default value.
	 * 
	 * @param organization - Organization object with AutoArchiveDurationDays field
	 * @returns Number of days to wait before auto-archiving (default from config)
	 */
	public static getAutoArchiveDurationDays(
		organization: { AutoArchiveDurationDays?: number | null } | null | undefined,
	): number {
		const defaultDays = 90;
		if (!organization) {
			return defaultDays; // Default for missing organization
		}
		
		// Always return a number - default from config if null/undefined
		return organization.AutoArchiveDurationDays ?? defaultDays;
	}
}
